module.exports = __webpack_public_path__ + "static/img/jlyd-ban.aa47fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jlyd-ban.jpg
// module id = hLTs
// module chunks = 1